class CartRemoveButton extends HTMLElement {
	constructor() {
		super()

		this.addEventListener('click', (event) => {
			event.preventDefault()
			const cartItems =
				this.closest('cart-items') || this.closest('cart-drawer-items')
			cartItems.updateQuantity(this.dataset.index, 0, null, event.target)
		})
	}
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
	constructor() {
		super()
		this.lineItemStatusElement =
			document.getElementById('shopping-cart-line-item-status') ||
			document.getElementById('CartDrawer-LineItemStatus')

		if (document.querySelector('.cart-shipping')) {
			this.minSpend = document.querySelector('.cart-shipping').dataset.minSpend;
			this.minTotal = Math.round(this.minSpend * (Shopify.currency.rate || 1));
			this.cartShipping();
		}

		const debouncedOnChange = debounce((event) => {
			this.onChange(event)
		}, ON_CHANGE_DEBOUNCE_TIMER)

		this.addEventListener('change', debouncedOnChange.bind(this))
	}

	cartUpdateUnsubscriber = undefined

	cartShipping() {
    let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');    
    document.documentElement.style.setProperty('--progress-prev', progressPrev);

    this.total = document.querySelector('.cart-shipping').dataset.total;
    this.progress = this.total / this.minTotal * 100;
    if (this.progress > 100)
      this.progress = 100;

		if (this.minTotal > this.total) {
      let amount = this.minTotal - this.total;
      let message = document.querySelector('.cart-shipping').dataset.message.replace('||amount||', formatMoney(amount));
      document.querySelector('.cart-shipping__message_default').innerText = message;
      document.querySelector('.cart-shipping__message_success').classList.remove('active');
      document.querySelector('.cart-shipping__message_default').classList.add('active');
    }
    else {
      document.querySelector('.cart-shipping__message_default').classList.remove('active');
      document.querySelector('.cart-shipping__message_success').classList.add('active');
    }

    document.querySelector('.cart-shipping__progress-current').style.width = this.progress+'%';
  }

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === 'cart-items') {
					return
				}
				this.onCartUpdate()
			}
		)
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber()
		}
	}

	onChange(event) {

		if(event.target.closest('.protection_service') != null || event.target.closest('.cart-footer-detail') != null){
			return;
		};

		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute('name'), event.target
		)
	}

	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart-items`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')
				const sourceQty = html.querySelector('cart-items')
				this.innerHTML = sourceQty.innerHTML
			})
			.catch((e) => {
				console.error(e)
			})
	}

	getSectionsToRender() {
		if(document.getElementById('main-cart-shipping') != null ){
			return [
				{
					id: 'main-cart-items',
					section: document.getElementById('main-cart-items').dataset.id,
					selector: '.js-contents',
				},
				{
					id: 'cart-icon-bubble',
					section: 'cart-icon-bubble',
					selector: '.shopify-section',
				},
				{
					id: 'cart-live-region-text',
					section: 'cart-live-region-text',
					selector: '.shopify-section',
				},
				{
					id: 'main-cart-footer',
					section: document.getElementById('main-cart-footer').dataset.id,
					selector: '.js-contents-totals',
				},
				{
					id: 'main-cart-shipping',
					section: document.getElementById('main-cart-shipping').dataset.id || null,
					selector: '.js-contents-shipping'
				}
			]
		}else{
			return [
				{
					id: 'main-cart-items',
					section: document.getElementById('main-cart-items').dataset.id,
					selector: '.js-contents',
				},
				{
					id: 'cart-icon-bubble',
					section: 'cart-icon-bubble',
					selector: '.shopify-section',
				},
				{
					id: 'cart-live-region-text',
					section: 'cart-live-region-text',
					selector: '.shopify-section',
				},
				{
					id: 'main-cart-footer',
					section: document.getElementById('main-cart-footer').dataset.id,
					selector: '.js-contents-totals',
				}
			]
		}
		
	}

	updateQuantity(line, quantity, name, ele_target = null) {

		if( ele_target.closest('[data-max-qty]') != null && quantity != 0 ){
			const ele_parent = ele_target.closest('[data-max-qty]');
			const maxQty = Number(ele_parent.dataset.maxQty);
			let temp_total = 0;
			ele_parent.querySelectorAll('.quantity__input').forEach((inp_ele)=>{
				temp_total = temp_total + Number(inp_ele.value);
			});
			if( temp_total > maxQty ){
				ele_target.value = ele_target.dataset.prevValue;				
				return;
			}
		}



		this.enableLoading(line, ele_target);
		let haProtectionPlan = false;
		let haServicePlan = false;
		let haExtendedWarranty = false;
		let hasProSer = false;
		let haBbqService = false;
		if( ele_target != null ){
			this.eleCartItem = ele_target.closest('.cart-item');
			haProtectionPlan = this.eleCartItem.dataset.protectionPlan == "true" ? true : false;
			haServicePlan = this.eleCartItem.querySelector('.services-list .services-item input[data-has-services="true"]') != null ? true : false;
			haExtendedWarranty = this.eleCartItem.querySelector('.cart_pro_extended') != null ? true : false;
			haBbqService = this.eleCartItem.dataset.servicePlan == "true" ? true : false;
		}		

		let body_data = {
			line: line,
			quantity: quantity,
			sections: this.getSectionsToRender().map((e => e.section)),
			sections_url: window.location.pathname
		}
		if( haProtectionPlan || haServicePlan || haExtendedWarranty || haBbqService ){
			hasProSer = true;
			body_data = {
				updates: {},
				sections: this.getSectionsToRender().map((e => e.section)),
				sections_url: window.location.pathname
			}
			console.log(body_data,'body_data1',haProtectionPlan,haServicePlan,haExtendedWarranty)
			let item_key = this.eleCartItem.dataset.itemKey;
			body_data.updates[item_key] = quantity;

			if( haProtectionPlan ){
				let protection_key = this.eleCartItem.querySelector('.protection_options').dataset.protectionKey;
				body_data.updates[protection_key] = quantity;
			}
			if( haServicePlan ){
				let service_key = this.eleCartItem.querySelector('.services-list .services-item input[data-has-services="true"]').dataset.keyVal;
				body_data.updates[service_key] = quantity;
			}
			if( haExtendedWarranty ){
				let Extended_key = this.eleCartItem.querySelector('.cart_pro_extended').dataset.key;
				body_data.updates[Extended_key] = quantity;
			}			

			if(haBbqService){
				let bbq_key = this.eleCartItem.querySelector('.protection_service .protection_options').dataset.protectionKey;
				body_data.updates[bbq_key] = quantity;
			}

			console.log(body_data,'body_data2');
		}
		this.querySelectorAll('.quantity__button').forEach((button) =>
			button.classList.add('disabled')
		)

		if (document.querySelectorAll('.card--product card__add-to-cart button[name="add"]')) {
			document.querySelectorAll('.card--product .card__add-to-cart button[name="add"]').forEach((button) => {
					button.setAttribute('aria-disabled', false)
					if (button.querySelector('span')) {
						button.querySelector('span').classList.remove('hidden')
						button.querySelector('.sold-out-message').classList.add('hidden')
					}
				})
		}

		if (document.querySelector('.cart-shipping')) {
      let progressPrev = getComputedStyle(document.querySelector('.cart-shipping__progress-current')).getPropertyValue('width');    
      document.documentElement.style.setProperty('--progress-prev', progressPrev);
    }

		// const body = JSON.stringify({
		// 	line,
		// 	quantity,
		// 	sections: this.getSectionsToRender().map((section) => section.section),
		// 	sections_url: window.location.pathname,
		// })

		const n = JSON.stringify(body_data);
		//document.body.classList.add('cart--loading');
		//console.log(body_data,'n2');
		fetch(`${ hasProSer ? routes.cart_update_url : routes.cart_change_url}`, {
			...fetchConfig(),
			body: n
		}).then((e => e.text())).then((t => {			
			setTimeout(() => {					
				let hasError = cartPageRender(t, true);
				if (hasError != undefined && hasError != ''){						
						const a = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`), 
						i = document.querySelectorAll(".cart-item");
						let _line = ele_target && ele_target.closest('[data-line-index]') ? ele_target.closest('[data-line-index]').dataset.lineIndex : line;
						(document.querySelector('cart-items') || document.querySelector('cart-drawer-items')).updateLiveRegions(_line, hasError);
						this.disableLoading(_line, ele_target);
						console.log('updateQuantity----------hasError');
						return;
				};
				cartPageRender(t);
				// console.log('calll');
			}, 250);			
		})).catch((() => {
			this.querySelectorAll(".loading-overlay").forEach((e => e.classList.add("hidden")));
			document.body.classList.remove('cart--loading');
			//(document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors")).textContent = window.cartStrings.error
		})).finally((() => {
			this.querySelectorAll('.quantity__button').forEach((button) =>
				button.classList.remove('disabled')
			)
			if (document.querySelector('.cart-shipping')) {
				this.cartShipping();
			}
			this.disableLoading(line, ele_target)
		}))

		/*fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text()
			})
			.then((state) => {
				const parsedState = JSON.parse(state)
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`)
				const items = document.querySelectorAll('.cart-item')
				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute('value')
					this.updateLiveRegions(line, parsedState.errors)
					return
				}

				this.classList.toggle('is-empty', parsedState.item_count === 0)
				const cartDrawerWrapper = document.querySelector('cart-drawer')
				const cartFooter = document.getElementById('main-cart-footer')

				if (cartFooter)
					cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						'is-empty',
						parsedState.item_count === 0
					)

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id)
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					)
				})
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined
				let message = ''
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === 'undefined') {
						message = window.cartStrings.error
					} else {
						message = window.cartStrings.quantityError.replace(
							'[quantity]',
							updatedValue
						)
					}
				}
				this.updateLiveRegions(line, message)

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`)
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus()
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector('.drawer__inner-empty'),
						cartDrawerWrapper.querySelector('a')
					)
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector('.cart-item__name')
					)
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
				//updateCartObj();
			})
			.catch(() => {
				this.querySelectorAll('.loading-overlay').forEach((overlay) =>
					overlay.classList.add('hidden')
				)
				this.querySelectorAll('.quantity__button').forEach((button) =>
					button.classList.remove('disabled')
				)
				const errors =
					document.getElementById('cart-errors') ||
					document.getElementById('CartDrawer-CartErrors')
				if (errors) errors.textContent = window.cartStrings.error
			})
			.finally(() => {
				this.querySelectorAll('.quantity__button').forEach((button) =>
					button.classList.remove('disabled')
				)
				if (document.querySelector('.cart-shipping')) {
          this.cartShipping();
        }
				this.disableLoading(line)
			})*/
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`)

		if (lineItemError) {
			if (message) {
				lineItemError.style.display = 'flex'
				lineItemError.querySelector('.cart-item__error-text').innerHTML =
					message
			} else {
				lineItemError.style.display = 'none'
				lineItemError.querySelector('.cart-item__error-text').innerHTML = ''
			}
		}

		this.lineItemStatusElement.setAttribute('aria-hidden', true)

		const cartStatus =
			document.getElementById('cart-live-region-text') ||
			document.getElementById('CartDrawer-LiveRegionText')
		cartStatus.setAttribute('aria-hidden', false)

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true)
		}, 1000)
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML
	}

	enableLoading(line, ele_target = null) {
		const mainCartItems =
			document.getElementById('main-cart-items') ||
			document.getElementById('CartDrawer-CartItems')
		if (mainCartItems) mainCartItems.classList.add('cart__items--disabled')
		
		line = ele_target && ele_target.closest('[data-line-index]') ? ele_target.closest('[data-line-index]').dataset.lineIndex : line;

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		)
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		)

		;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>{			
			if( ele_target != null && ele_target.closest('.cart-item__bottom') ){
				ele_target.closest('.cart-item__bottom').querySelector('.loading-overlay').classList.remove('hidden')
			}else{
				overlay.classList.remove('hidden')
			}			
		})

		document.activeElement.blur()
		this.lineItemStatusElement.setAttribute('aria-hidden', false)
	}

	disableLoading(line, ele_target = null) {
		const mainCartItems =
			document.getElementById('main-cart-items') ||
			document.getElementById('CartDrawer-CartItems')
		if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled')
		
		line = ele_target && ele_target.closest('[data-line-index]') ? ele_target.closest('[data-line-index]').dataset.lineIndex : line;

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		)
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		)

		cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
		cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))
	}
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
	customElements.define(
		'cart-note',
		class CartNote extends HTMLElement {
			constructor() {
				super()
				const tis = this;

				this.addEventListener(
					'change',
					debounce((event) => {						
						tis.querySelector('.note-submit') && (
							tis.querySelector('.note-submit').classList.add('loading'),
							tis.querySelector('.note-submit .loading-overlay__spinner').classList.remove('hidden'),
							tis.classList.toggle('active')
						);
						const body = JSON.stringify({ note: event.target.value })
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						}).then(()=>{							
							tis.querySelector('.note-submit') && (
								tis.querySelector('.note-submit .loading-overlay__spinner').classList.add('hidden'),
								tis.querySelector('.note-submit').classList.remove('loading')								
							);
							if(tis.closest('cart-drawer') ){
								if(tis.querySelector('textarea').value != ''){
									tis.querySelector('.note-not-empty').classList.remove('hidden');
									tis.querySelector('.note--empty').classList.add('hidden');
								}else{
									tis.querySelector('.note-not-empty').classList.add('hidden');
									tis.querySelector('.note--empty').classList.remove('hidden');
								}
							}
						})
					}, ON_CHANGE_DEBOUNCE_TIMER)
				)
			}
		}
	)
}

class cartItemRecommended extends HTMLElement {
	constructor() {
		super();		
		this.querySelector('.cait-reco-add-btn').addEventListener('click', this.cartRecommendedAdd.bind(this))
	}

	cartRecommendedAdd(event) {
		const clickEle = this.querySelector('.cait-reco-add-btn');
		const haDrawer = clickEle.dataset.drawer != null ? true : false;
		const data_obj = {
			id: clickEle.dataset.varaintId,
			properties: {
				_reference_product: clickEle.dataset.refeHandle
			}
		};		
		var cart = document.querySelector('cart-items');
		if( haDrawer ){
			cart = document.querySelector('cart-drawer cart-drawer-items');
		}
		data_obj.sections = cart.getSectionsToRender().map((e => e.section));
		data_obj.sections_url = window.location.pathname;

		event.preventDefault();		

		const o = JSON.stringify(data_obj); 
		fetch(`${ routes.cart_add_url }`, {
			...fetchConfig(),
			body: o
	 })
	 .then((e => e.json()))
	 .then((t => {			
			if( haDrawer ){
				document.querySelector('cart-drawer').renderContents(t);
			}else{
				document.querySelector('cart-items').getSectionsToRender().forEach((e => {
					(document.getElementById(e.id).querySelector(e.selector) ||
					document.getElementById(e.id)).innerHTML = document.querySelector('cart-items').getSectionInnerHTML(t.sections[e.section], e.selector)
			 }));
			}
	 }))
	}
}
customElements.define('cart-item-recommended', cartItemRecommended)

/* Update cart html */
function cartPageRender(cart_response, checkforError = false, getJson = false){     
  
  const n = JSON.parse(cart_response);
  // console.log('cartPageRender ==> n', n);
  if( checkforError ) {
     return n.errors;
  }

  let cart_count = n.item_count;   
  if( cart_count == undefined ){
     cart_count = Number((new DOMParser).parseFromString(n.sections['cart-icon-bubble'], "text/html").querySelector('.cart-count-bubble span').innerHTML.trim());
  }
  
  document.querySelector("[data-cart-item-count]") && cart_count != undefined &&
   (document.querySelector("[data-cart-item-count]").innerHTML = `${ cart_count } item${ cart_count > 1 ? 's': '' }`);

   var cartItemSelector = document.querySelector('cart-items');
   if ( cartItemSelector == null ){
      cartItemSelector = document.querySelector('cart-drawer cart-drawer-items');
   }
   
   cartItemSelector.getSectionsToRender().forEach((e => {      
     (document.getElementById(e.id).querySelector(e.selector) ||
     document.getElementById(e.id)).innerHTML = cartItemSelector.getSectionInnerHTML(n.sections[e.section], e.selector)
  }));



  if(n.item_count!= undefined && n.item_count == 0){
   cartItemSelector.classList.add('is-empty');
  }
  //updateCartObj();
}
/* Update cart html END */